/* global IntersectionObserver */

import 'intersection-observer'

const CONTAINER_SELECTOR = '[data-module="floating-button"]'

const THRESHOLD = 0.16
const SHOW = 'block'
const HIDE = 'none'

/*
  TODO

  - [ ] listen for changes in `[data-variant-select]` and update the "price" in $element
        https://developer.mozilla.org/en-US/docs/Web/API/HTMLSelectElement/selectedOptions
*/

export default function () {
  // No more than one.
  let $element = document.querySelector(CONTAINER_SELECTOR)
  if ($element != null) init($element)
}

function init ($element) {
  const $target = document.querySelector('[data-floating-button-target]')

  if ($target == null) return

  const observer = new IntersectionObserver(callback, {
    threshold: [0, THRESHOLD]
  })
  observer.observe($target)

  function callback(entries) {
    const entry = entries.pop()
    
    if (entry.isIntersecting && entry.intersectionRatio > THRESHOLD) {
      $element.classList.add(SHOW)
      $element.classList.remove(HIDE)
    } else {
      $element.classList.add(HIDE)
      $element.classList.remove(SHOW)
    }
  }
}
